export const getSingleCategory = (payload?: any) => ({
    type: "@saga/GET_SINGLE_CATEGORY",
    payload
});

